import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { Link } from 'stile-shared/src/components/2024/common/Link';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="The complete guide to implement VTLM 2.0"
      description="Download Stile's complete guide to implementing the Victorian Teaching and Learning Model 2.0, including a self-assessment to determine your priorities."
      slug={props.location.pathname}
    />
  );
}

function VicCurriculumPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="The complete guide to implement VTLM 2.0"
        id="VIC_CURRICULUM_2026"
        redirectUrl="https://stileapp.com/go/vtlm2"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/vic_vtlm_guide_rect.jpg"
            alt="The Victorian Teaching and Learning Model 2.0 — Stile's guide to implementation"
          />
        }
      >
        <p>
          Stile&apos;s instructional model is underpinned by the same evidence base as the most
          recent Victorian Teaching and Learning Model. This means teaching with Stile is
          implementing VTLM 2.0.
        </p>
        <p>
          Download our complete guide to implementation, including a self-assessment to determine
          your priorities in preparing for the{' '}
          <Link
            url="https://arc.educationapps.vic.gov.au/learning/sites/vtlmresources"
            openInNewTab
          >
            Department
          </Link>
          &apos;s &ldquo;full mandatory embedding in teaching and learning programs across all
          schools&rdquo; by the start of 2028.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default VicCurriculumPage;
